import { c as _c } from "react/compiler-runtime";
import { useChainId, useChains, useSwitchChain } from "wagmi";
type UseChainSwitcherResult = {
  chains: ReturnType<typeof useChains>;
  currentChainName: string;
  nextChainName: string;
  switchToNextChain: () => boolean;
};
function getNextChain(chains: ReturnType<typeof useChains>, chainId: number) {
  if (chains.length < 2) {
    return undefined;
  }
  const currentIndex = chains.findIndex(chain => chain.id === chainId);
  for (let offset = 1; offset <= chains.length; offset++) {
    const nextIndex = currentIndex === -1 ? offset - 1 : (currentIndex + offset) % chains.length;
    const nextChain = chains[nextIndex];
    if (nextChain && nextChain.id !== chainId) {
      return nextChain;
    }
  }
  return undefined;
}
export function useChainSwitcher() {
  const $ = _c(14);
  const chains = useChains();
  const chainId = useChainId();
  const {
    switchChain
  } = useSwitchChain();
  let t0;
  if ($[0] !== chainId || $[1] !== chains) {
    t0 = chains.find(chain => chain.id === chainId)?.name ?? chainId.toString();
    $[0] = chainId;
    $[1] = chains;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const currentChainName = t0;
  let t1;
  if ($[3] !== chainId || $[4] !== chains) {
    t1 = getNextChain(chains, chainId);
    $[3] = chainId;
    $[4] = chains;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const nextChain = t1;
  const nextChainName = nextChain?.name ?? "";
  let t2;
  if ($[6] !== nextChain || $[7] !== switchChain) {
    t2 = () => {
      if (!nextChain) {
        return false;
      }
      switchChain({
        chainId: nextChain.id
      });
      return true;
    };
    $[6] = nextChain;
    $[7] = switchChain;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const switchToNextChain = t2;
  let t3;
  if ($[9] !== chains || $[10] !== currentChainName || $[11] !== nextChainName || $[12] !== switchToNextChain) {
    t3 = {
      chains,
      currentChainName,
      nextChainName,
      switchToNextChain
    };
    $[9] = chains;
    $[10] = currentChainName;
    $[11] = nextChainName;
    $[12] = switchToNextChain;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}